import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { colorSystem, Text, Tooltip } from '@luminovo/design-system';

export const UnknownValue: React.FunctionComponent = () => (
    <Tooltip title={t`Unknown`}>
        <Text variant="body" color={colorSystem.neutral[6]}>
            <Trans>-</Trans>
        </Text>
    </Tooltip>
);
